import { createLocalStorageStore } from 'features/entryBrowser/hooks/createLocalStorageStore'

export interface SearchQueryHistoryEntry {
  query: string
  contentFilter: string
  timestamp: number
}

const MAX_QUERIES = 1000
const STORAGE_KEY_PREFIX = 'gecko_search_query_history:v1'

function getStorageKey(userId: string, siteId: string): string {
  return `${STORAGE_KEY_PREFIX}_${userId}_${siteId}`
}

const storeCache = new Map<
  string,
  ReturnType<typeof createLocalStorageStore<SearchQueryHistoryEntry>>
>()

export function getSearchQueryHistoryStore(userId: string, siteId: string) {
  const key = getStorageKey(userId, siteId)
  let store = storeCache.get(key)
  if (!store) {
    store = createLocalStorageStore<SearchQueryHistoryEntry>(key, MAX_QUERIES)
    storeCache.set(key, store)
  }
  return store
}
